var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04343 1.07095C1.96319 0.990718 1.86793 0.927072 1.7631 0.883648C1.65827 0.840224 1.5459 0.817873 1.43243 0.817873C1.31896 0.817873 1.2066 0.840224 1.10177 0.883648C0.996932 0.927072 0.901677 0.990718 0.821441 1.07095C0.741204 1.15119 0.677558 1.24645 0.634134 1.35128C0.59071 1.45611 0.568359 1.56848 0.568359 1.68195C0.568359 1.79542 0.59071 1.90778 0.634134 2.01261C0.677558 2.11745 0.741204 2.2127 0.821441 2.29294L9.45737 10.9289C9.53757 11.0092 9.63282 11.0729 9.73766 11.1163C9.84249 11.1598 9.95487 11.1821 10.0684 11.1821C10.1818 11.1821 10.2942 11.1598 10.3991 11.1163C10.5039 11.0729 10.5991 11.0092 10.6794 10.9289L19.3153 2.29294C19.4773 2.13089 19.5684 1.91111 19.5684 1.68195C19.5684 1.45278 19.4773 1.233 19.3153 1.07095C19.1532 0.908909 18.9335 0.817872 18.7043 0.817872C18.4751 0.817872 18.2553 0.908909 18.0933 1.07095L10.0684 9.09697L2.04343 1.07095Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDown);
export default __webpack_public_path__ + "static/media/expandDown.4a5377e2f7965694ce39a9bce0bcf0b5.svg";
export { ForwardRef as ReactComponent };